"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalParameterValue = void 0;
var vue_1 = require("vue");
var TranslateMixin_1 = require("./TranslateMixin");
var constants_1 = require("../constants");
var GlobalParameter_1 = require("../GlobalParameter");
exports.GlobalParameterValue = vue_1.default.component('global-parameter-value', {
    props: {
        param: {
            type: Number,
        },
        value: {
            type: Number,
        },
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        isMax: function () {
            switch (this.param) {
                case GlobalParameter_1.GlobalParameter.TEMPERATURE:
                    return this.value === constants_1.MAX_TEMPERATURE;
                case GlobalParameter_1.GlobalParameter.OXYGEN:
                    return this.value === constants_1.MAX_OXYGEN_LEVEL;
                case GlobalParameter_1.GlobalParameter.OCEANS:
                    return this.value === constants_1.MAX_OCEAN_TILES;
                case GlobalParameter_1.GlobalParameter.VENUS:
                    return this.value === constants_1.MAX_VENUS_SCALE;
                default:
                    return false;
            }
        },
        getIconClass: function () {
            switch (this.param) {
                case GlobalParameter_1.GlobalParameter.TEMPERATURE:
                    return 'temperature-tile';
                case GlobalParameter_1.GlobalParameter.OXYGEN:
                    return 'oxygen-tile';
                case GlobalParameter_1.GlobalParameter.OCEANS:
                    return 'ocean-tile';
                case GlobalParameter_1.GlobalParameter.VENUS:
                    return 'venus-tile';
                default:
                    return '';
            }
        },
    },
    template: "\n<div>\n  <div :class=\"getIconClass()\"></div>\n  <div class=\"global_params_value\">\n    <div v-if=\"isMax()\">\n      <img src=\"/assets/misc/checkmark.png\" class=\"checkmark\" :alt=\"$t('Completed!')\">\n    </div>\n    <div v-else>\n      {{this.value}}\n    </div>\n  </div>\n</div>\n  ",
});
//# sourceMappingURL=GlobalParameterValue.js.map